// extracted by mini-css-extract-plugin
export default {"button":"button___JtdgB","disabled":"disabled___p3Kcm","active":"active___xCoE5","tealColor":"tealColor___tIJJz","greenColor":"greenColor___O0332"};